<template>
	<div class="leave-container">
		<div class="mb-3">
			<v-btn
				color="#00AAFD" 
				@click="calculate_leave()" 
				class="text-capitalize white--text mr-2"
			>
				Calculate Leave
			</v-btn>
			<v-btn 
				color="#00AAFD" 
				@click="new_leave(0)" 
				class="text-capitalize white--text"
			>
				<span>Request Leave</span>
			</v-btn>
		</div>
		<v-alert type="error" v-if="errormsg.length !== 0">
			{{ errormsg }}
		</v-alert>
		<div class="leave-content">
			<div class="leave-title mb-3">
				<div class="leave-summary pl-1">Leave Summary</div>
				<v-menu
					v-model="menu"
					transition="scale-transition"
					offset-y
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn class="date-text" color="#FAFAFA" v-bind="attrs" v-on="on">
							Date range
							<v-icon small color="#192A3E" class="ml-2">mdi-calendar</v-icon>
						</v-btn>
					</template>
					<v-row justify="space-around">
						<v-date-picker
							v-model="date_range"
							no-title
							range
							@input="onDateChange($event)"
						></v-date-picker>
					</v-row>
				</v-menu>
			</div>
			<ProgressGetDataLinear v-if="loading"/>
			<LeaveTable v-if="!loading" :items="leave_data" :color="$attrs.color" @row-click="new_leave($event)"/>
		</div>
	</div>
</template>
<script>
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import LeaveTable from "@/views/leave/leave_table.vue";
import moment from 'moment';

export default {
	name: 'Leave',
	components: {
		ProgressGetDataLinear,
		LeaveTable
	},
	data() {
		return {
			loading: false,
			errormsg: '',
			start_date: moment().subtract(1, 'years').format('YYYY-MM-DD'),
			end_date: moment().add(1, 'months').format('YYYY-MM-DD'),
			leave_data: [],
			menu: false,
			date_range: [],
		}
	},
	created() {
		this.load_leave();
		this.date_range = [this.start_date, this.end_date];

		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Leave Summary",
			to: this.$route.path
		});
	},
	watch: {
		user_abid() {
			this.load_leave();
		}
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
	},
	methods: {
		load_leave() {
			if (this.user_abid === 0) return;
      
			this.loading = true;

			const params = [];
			params.push("employees=" + this.user_abid);
			params.push("event_types=" + [2,3,4,5,6]);

			if (this.start_date) {
				params.push('start_date='+ this.start_date);
			}
			if (this.end_date) {
				params.push('end_date='+ this.end_date);
			}
			
			let url = "/api/leave";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) === 'string') {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status === "OK") {
						const date_tmp = data;
						date_tmp.sort((a,b) => {return b.id - a.id });

						this.leave_data = date_tmp;
						this.loading = false;
					} else {
						this.errormsg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				}).finally(() => {
					this.loading = false;
				});
				
		},
		onDateChange(datas) {
			if (datas.length === 2 && datas[0] !== datas[1]) {
				this.start_date = datas[0] < datas[1] ? datas[0] : datas[1];
				this.end_date = datas[0] < datas[1] ? datas[1] : datas[0];
				this.load_leave();
				this.menu = false;
			}
		},
		calculate_leave() {
			// need to add edit funtion here
			this.$router.push({name:"Leave Calculator"})	
		},
		new_leave(leave_id) {
			// need to open a new create leave window 
			this.$router.push({ name: "Edit Leave", params: { id: leave_id } });
		},
	}

}
</script>
<style lang="scss" scoped>
.leave-container {
  padding: 12px; 
  background: white;
}
.leave-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.leave-summary {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
.date-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;
	color: #192A3E;
}
</style>